module.exports = __webpack_public_path__ + "img/siri.39bd0e67.jpg";